<div
  class="main-section relative font-nunito font-normal antialiased"
  [ngClass]="[store.sidebar ? 'toggle-sidebar' : '', store.menu, store.layout, store.rtlClass]"
  appDynamicFontSize="body"
  style="background-color: var(--app-bg-color, var(--app-bg-color-default)); color: var(--app-text-color, var(--app-text-color-default))"
>
  <!--  BEGIN MAIN CONTAINER  -->
  <div class="relative" style="background-color: var(--app-bg-color, var(--app-bg-color-default)); color: var(--app-text-color, var(--app-text-color-default))">
    <!-- sidebar menu overlay -->
    <div
      class="fixed inset-0 z-50 bg-[black]/60 lg:hidden"
      [ngClass]="{ hidden: !store.sidebar }"
      (click)="storeData.dispatch({ type: 'toggleSidebar' })"
    ></div>

    <!-- Pull-to-refresh indicator (native mobile only) -->
    @if (pullToRefreshEnabled) {
    <div #pullRefreshIndicator class="pull-refresh-indicator">
      <i class="fa-solid fa-arrow-down pull-refresh-icon"></i>
      <i class="fa-solid fa-spinner fa-spin pull-refresh-spinner" style="display: none"></i>
    </div>
    }

    <!-- screen loader -->
    @if (isLoading) {
    <div
      class="screen_loader animate__animated fixed inset-0 z-[60] grid place-content-center bg-[#fafafa] dark:bg-[#060818]"
      style="background-color: var(--app-bg-color, var(--app-bg-color-default))"
    >
      <svg
        width="64"
        height="64"
        viewBox="0 0 135 135"
        xmlns="http://www.w3.org/2000/svg"
        fill="var(--app-form-base-component-color, var(--app-primary-color))"
      >
        <path
          d="M67.447 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm9.448 9.447c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10zm-9.448 9.448c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zM58 67.447c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10z"
        >
          <animatetransform attributeName="transform" type="rotate" from="0 67 67" to="-360 67 67" dur="2.5s" repeatCount="indefinite" />
        </path>
        <path
          d="M28.19 40.31c6.627 0 12-5.374 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.626 5.372 12 12 12zm30.72-19.825c4.686 4.687 12.284 4.687 16.97 0 4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97zm35.74 7.705c0 6.627 5.37 12 12 12 6.626 0 12-5.373 12-12 0-6.628-5.374-12-12-12-6.63 0-12 5.372-12 12zm19.822 30.72c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.686 12.285 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.685-4.687-12.283-4.687-16.97 0zm-7.704 35.74c-6.627 0-12 5.37-12 12 0 6.626 5.373 12 12 12s12-5.374 12-12c0-6.63-5.373-12-12-12zm-30.72 19.822c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.687-4.686 12.285 0 16.97 4.686 4.687 12.284 4.687 16.97 0 4.687-4.685 4.687-12.283 0-16.97zm-35.74-7.704c0-6.627-5.372-12-12-12-6.626 0-12 5.373-12 12s5.374 12 12 12c6.628 0 12-5.373 12-12zm-19.823-30.72c4.687-4.686 4.687-12.284 0-16.97-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0z"
        >
          <animatetransform attributeName="transform" type="rotate" from="0 67 67" to="360 67 67" dur="8s" repeatCount="indefinite" />
        </path>
      </svg>
    </div>
    }

    <!-- Voice Search Section -->
    @if (enableVoiceSearch) {
    <div class="fixed bottom-20 z-50 flex flex-col items-center space-y-2 ltr:right-8 rtl:left-6">
      <div class="relative">
        <button
          class="btn btn-outline-primary relative rounded-full bg-[#fafafa] p-3 dark:bg-[#060818] dark:hover:bg-primary"
          (mousedown)="startHold(); micHoverText = 'Release to translate'; showTooltip = true"
          (mouseup)="endHold(); showTooltip = false"
          (mouseleave)="endHold(); showTooltip = false"
          (touchstart)="startHold()"
          (touchend)="endHold()"
          (mouseenter)="micHoverText = isRecording ? 'Release to translate' : (isPreviewOpen ? 'Click to close' : 'Click to open or hold to record'); showTooltip = true"
          (mouseleave)="micHoverText = 'Click to open or hold to record'; showTooltip = false"
        >
          @if (!isRecording && !audioBlob) {
          <i [class]="isPreviewOpen ? 'fa fa-times' : 'fa fa-microphone'"></i>
          } @if (isRecording) {
          <i class="fa fa-stop"></i>
          } @if (!isRecording && audioBlob) {
          <i class="fa fa-microphone"></i>
          }
        </button>
        <!-- Custom Tooltip -->
        @if (micHoverText && showTooltip) {
        <div
          class="pointer-events-none absolute bottom-full right-0 z-10 mb-3 max-w-[220px] whitespace-nowrap rounded-lg bg-gray-800 px-3 py-2 text-center text-xs text-white shadow-lg"
        >
          {{ micHoverText }}
          <div class="absolute right-4 top-full h-0 w-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"></div>
        </div>
        }
      </div>
    </div>
    }

    <!-- Transcription Preview - Enhanced UI -->
    @if (enableVoiceSearch && (isPreviewOpen || isTranscribing || hasTranscriptionData)) {
    <div class="fixed left-6 right-32 top-3/4 z-50 -translate-y-1/2 transform">
      <div
        class="relative w-full rounded-2xl border border-gray-100 bg-white p-5 shadow-2xl backdrop-blur-sm dark:border-gray-700 dark:bg-gray-800"
        style="min-height: 140px"
      >
        <!-- Header with Close Button -->
        <div class="mb-3 flex items-center justify-between">
          <div class="flex items-center space-x-2">
            <div class="h-2 w-2 animate-pulse rounded-full bg-blue-500"></div>
            <h3 class="text-sm font-semibold text-gray-700 dark:text-gray-200">
              @if (isTranscribing) {
              <span class="text-blue-600 dark:text-blue-400">Transcribing...</span>
              } @if (!isTranscribing && displayedText) {
              <span class="text-green-600 dark:text-green-400">Ready to Send</span>
              }
            </h3>
          </div>
          <button
            (click)="closeTranscriptionPreview()"
            class="text-gray-400 transition-all duration-200 hover:rotate-90 hover:text-red-500 dark:hover:text-red-400"
          >
            <i class="fas fa-times text-lg"></i>
          </button>
        </div>
        <div class="relative">
          @if (isTranscribing) {
          <div class="relative">
            <div class="absolute inset-0 rounded-xl bg-gradient-to-r from-blue-50 to-transparent dark:from-blue-900/20"></div>
            @if (isTranscribing) {
            <textarea
              class="w-full resize-none rounded-xl border-2 border-blue-200 bg-transparent p-4 text-sm text-gray-700 focus:border-transparent focus:ring-2 focus:ring-blue-500 dark:border-blue-800 dark:text-gray-200"
              style="height: 5.5rem"
              rows="5"
              placeholder="Transcribing..."
              readonly
            >
                    {{ transcribingText }}
                  </textarea
            >
            }
            <div class="absolute bottom-3 right-3">
              <div class="flex space-x-1">
                <div class="h-3 w-1 animate-bounce rounded-full bg-blue-500"></div>
                <div class="h-3 w-1 animate-bounce rounded-full bg-blue-500" style="animation-delay: 0.1s"></div>
                <div class="h-3 w-1 animate-bounce rounded-full bg-blue-500" style="animation-delay: 0.2s"></div>
              </div>
            </div>
          </div>
          } @if (!isTranscribing && !hasTranscriptionData && isPreviewOpen) {
          <div class="relative">
            <textarea
              [(ngModel)]="displayedText"
              (keydown)="handleEnterKey($event)"
              class="w-full resize-none rounded-xl border-2 border-gray-200 bg-gray-50 p-4 pr-16 text-sm text-gray-700 transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-900 dark:text-gray-200 dark:focus:border-blue-400"
              rows="5"
              placeholder="Type your message here... (Press Enter to send)"
            >
            </textarea>
            <div class="absolute bottom-3 right-3 flex items-center space-x-2">
              <span class="text-xs text-gray-400 dark:text-gray-500">{{ displayedText.length }} chars</span>
              <button
                (click)="sendTranscribedText()"
                class="transform rounded-full bg-gradient-to-r from-blue-500 to-blue-600 p-2.5 text-white shadow-lg transition-all duration-200 hover:scale-105 hover:from-blue-600 hover:to-blue-700 hover:shadow-xl"
              >
                <i class="fas fa-paper-plane text-sm"></i>
              </button>
            </div>
          </div>
          } @if (!isTranscribing && hasTranscriptionData) {
          <div class="relative">
            <textarea
              [(ngModel)]="displayedText"
              (keydown)="handleEnterKey($event)"
              class="w-full resize-none rounded-xl border-2 border-gray-200 bg-gray-50 p-4 pr-16 text-sm text-gray-700 transition-all duration-200 focus:border-green-500 focus:ring-2 focus:ring-green-500 dark:border-gray-600 dark:bg-gray-900 dark:text-gray-200 dark:focus:border-green-400"
              rows="5"
              placeholder="Edit transcription... (Press Enter to send)"
            >
            </textarea>
            <div class="absolute bottom-3 right-3 flex items-center space-x-2">
              <span class="text-xs text-gray-400 dark:text-gray-500">{{ displayedText.length }} chars</span>
              <button
                (click)="sendTranscribedText()"
                class="transform rounded-full bg-gradient-to-r from-blue-500 to-blue-600 p-2.5 text-white shadow-lg transition-all duration-200 hover:scale-105 hover:from-blue-600 hover:to-blue-700 hover:shadow-xl"
              >
                <i class="fas fa-paper-plane text-sm"></i>
              </button>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
    } @if (showTopButton) {
    <div class="fixed bottom-6 z-50 ltr:right-6 rtl:left-6">
      <button
        type="button"
        class="btn btn-outline-primary animate-pulse rounded-full bg-[#fafafa] p-2 dark:bg-[#060818] dark:hover:bg-primary"
        style="background-color: var(--app-bg-color, var(--app-bg-color-default)); color: var(--app-text-color, var(--app-text-color-default))"
        (click)="goToTop()"
      >
        <svg width="24" height="24" class="h-4 w-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            opacity="0.5"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 20.75C12.4142 20.75 12.75 20.4142 12.75 20L12.75 10.75L11.25 10.75L11.25 20C11.25 20.4142 11.5858 20.75 12 20.75Z"
            fill="currentColor"
          />
          <path
            d="M6.00002 10.75C5.69667 10.75 5.4232 10.5673 5.30711 10.287C5.19103 10.0068 5.25519 9.68417 5.46969 9.46967L11.4697 3.46967C11.6103 3.32902 11.8011 3.25 12 3.25C12.1989 3.25 12.3897 3.32902 12.5304 3.46967L18.5304 9.46967C18.7449 9.68417 18.809 10.0068 18.6929 10.287C18.5768 10.5673 18.3034 10.75 18 10.75L6.00002 10.75Z"
            fill="currentColor"
          />
        </svg>
      </button>
    </div>
    }

    <!-- BEGIN APP SETTING LAUNCHER -->
    <setting></setting>
    <!-- END APP SETTING LAUNCHER -->

    <div
      class="main-container min-h-screen text-black dark:text-white-dark"
      [ngClass]="[store.navbar]"
      style="background-color: var(--app-bg-color, var(--app-bg-color-default)); color: var(--app-text-color, var(--app-text-color-default))"
    >
      <!--  BEGIN SIDEBAR  -->
      <sidebar></sidebar>
      <!--  END SIDEBAR  -->

      <div
        class="main-content flex min-h-screen flex-col"
        style="background-color: var(--app-bg-color, var(--app-bg-color-default)); color: var(--app-text-color, var(--app-text-color-default))"
      >
        <!--  BEGIN TOP NAVBAR  -->
        <header></header>
        <!--  END TOP NAVBAR  -->

        <!--  BEGIN CONTENT AREA  -->
        <div
          class="animation p-6"
          style="background-color: var(--app-bg-color, var(--app-bg-color-default)); color: var(--app-text-color, var(--app-text-color-default))"
        >
          <router-outlet></router-outlet>
        </div>
        <!--  END CONTENT AREA  -->

        <!-- BEGIN FOOTER -->
        <!-- <footer class="mt-auto"></footer> -->
        <!-- END FOOTER -->
      </div>
    </div>
  </div>
</div>
